import { render } from "./SuperInvestorMarketDataCenter.vue?vue&type=template&id=98056526&scoped=true"
import script from "./SuperInvestorMarketDataCenter.vue?vue&type=script&lang=js"
export * from "./SuperInvestorMarketDataCenter.vue?vue&type=script&lang=js"

import "./SuperInvestorMarketDataCenter.vue?vue&type=style&index=0&id=98056526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98056526"]])

export default __exports__